/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dice Roller`)
};

const es_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzador de Dados`)
};

const de_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Würfel-Generator`)
};

const nl_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobbelsteen Gooier`)
};

const fr_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanceur de Dés`)
};

const it_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanciadadi`)
};

const pt_br2_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolador de Dados`)
};

const pt_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançador de Dados`)
};

const ja_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイコロ`)
};

const zh_dice_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`骰子生成器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_tool_name", locale)
	if (locale === "en") return en_dice_tool_name(inputs)
	if (locale === "es") return es_dice_tool_name(inputs)
	if (locale === "de") return de_dice_tool_name(inputs)
	if (locale === "nl") return nl_dice_tool_name(inputs)
	if (locale === "fr") return fr_dice_tool_name(inputs)
	if (locale === "it") return it_dice_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_dice_tool_name(inputs)
	if (locale === "pt") return pt_dice_tool_name(inputs)
	if (locale === "ja") return ja_dice_tool_name(inputs)
	return zh_dice_tool_name(inputs)
};